module.exports = __webpack_public_path__ + "static/img/8.ba6b7e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/8.png
// module id = dEVU
// module chunks = 0